import { render } from "./WidgetData.vue?vue&type=template&id=dcb74fe8"
import script from "./WidgetData.vue?vue&type=script&lang=js"
export * from "./WidgetData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__